import { useState } from 'react';
import { EmailInput } from './EmailInput';
import { useEmailValidation } from '../hooks/useEmailValidation';
import { useAuth } from '../hooks/useAuth';
import { EmailSentPrompt } from './EmailSentPrompt';
import { Button } from '@/components/ui/button';

export function LoginForm() {
  const [username, setUsername] = useState('');
  const [loginError, setLoginError] = useState<string | null>(null);
  const { validateEmail, getFullEmail } = useEmailValidation();
  const { login, session } = useAuth();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validationError = validateEmail(username);
    if (validationError) {
      setLoginError(validationError);
      return;
    }
    
    setLoginError(null);
    const email = getFullEmail(username);
    
    try {
      await login(email);
    } catch {
      // Error is already handled in AuthContext
    }
  };

  // Show success state when magic link was sent
  if (session.email) {
    return (
      <EmailSentPrompt
        email={session.email}
        devToken={session.devToken || undefined}
      />
    );
  }

  // Show login form when magic link not sent
  return (
    <form 
      className="space-y-4 sm:space-y-6" 
      onSubmit={handleSubmit}
      aria-label="login"
    >
      <EmailInput 
        value={username}
        onChange={(value) => {
          setUsername(value);
          setLoginError(null);
        }}
        error={loginError || session.error}
        autoFocus
      />
      <Button
        type="submit"
        disabled={session.isLoading}
        className="block mx-auto w-full lg:w-72"
      >
        {session.isLoading ? 'Sending...' : 'Send Magic Link'}
      </Button>
    </form>
  );
}
